import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  signal,
} from '@angular/core';
import { EWorkshopService } from '../../../features/e-workshop/services/e-workshop.service';
import { firstValueFrom } from 'rxjs';
import { Swiper } from 'swiper/types';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { EWorkshopCardComponent } from '../../../features/e-workshop/components/e-workshop-card/e-workshop-card.component';
import { NgIconsModule } from '@ng-icons/core';
import { AfraImageComponent } from '../../../shared/components/afra-image/afra-image.component';

@Component({
  selector: 'app-e-workshops-section',
  standalone: true,
  templateUrl: './e-workshops-section.html',
  styleUrl: './e-workshops-section.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
    EWorkshopCardComponent,
    NgIconsModule,
    AfraImageComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EWorkshopsSection {
  eWorkshopService = inject(EWorkshopService);

  eworkshops = signal<any[]>([]);
  constructor() {
    this.loadData();
  }
  async loadData() {
    this.eworkshops.set(
      (
        await firstValueFrom(this.eWorkshopService.getWorkshops())
      ).results.slice(0, 5),
    );
  }
}
